var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconEye(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\xE7\x9B\xAE\xE3\x81\xAE\xE3\x83\x95\xE3\x83\xAA\xE3\x83\xBC\xE3\x82\xA2\xE3\x82\xA4\xE3\x82\xB3\xE3\x83\xB3\xE7\xB4\xA0\xE6\x9D\x90 1",
    clipPath: "url(#clip0_1237_1721)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M19.7015 8.94141C18.6828 7.28371 16.0022 4.26172 9.99736 4.26172C4.01576 4.26172 1.33271 7.26039 0.305098 8.92211C-0.101699 9.58008 -0.101699 10.4189 0.305098 11.0768C1.33271 12.7386 4.01572 15.7373 9.99736 15.7373C16.0022 15.7373 18.6828 12.7153 19.7015 11.0576C20.0995 10.41 20.0995 9.58902 19.7015 8.94141ZM14.3939 10.5825C14.1417 12.5578 12.5444 14.1509 10.5685 14.3975C7.67189 14.7591 5.23783 12.325 5.59939 9.4284C5.84596 7.45246 7.43916 5.8552 9.41439 5.60305C12.3184 5.2323 14.7646 7.67851 14.3939 10.5825Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M11.0083 9.44473C10.762 9.37387 10.5607 9.17402 10.4886 8.92809C10.3682 8.51773 10.5798 8.13328 10.9175 7.98301C10.6371 7.85395 10.3267 7.78223 9.99806 7.78223C8.76369 7.78223 7.7631 8.79551 7.7815 10.0327C7.79896 11.2084 8.7888 12.1982 9.96451 12.2157C11.2017 12.2341 12.2151 11.2335 12.2151 9.99906C12.2151 9.63266 12.125 9.28574 11.966 8.98063C11.8253 9.33699 11.4301 9.56606 11.0083 9.44473Z",
    fill: "currentColor"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1237_1721"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEye);
export default __webpack_public_path__ + "static/media/icon_eye.f82f74dd9d32c2cc12a697d335d8ab5a.svg";
export { ForwardRef as ReactComponent };